import { render } from "./intro-card.vue?vue&type=template&id=96b02de6&lang=pug"
import script from "./intro-card.vue?vue&type=script&lang=js"
export * from "./intro-card.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__